import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import xss from 'xss';
export function xssValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; 
    }
    const sanitizedValue = xss(control.value);
    if (sanitizedValue != control.value) {
      return { xss: { value: control.value } };
    }

    return null;
  };
}
